/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingUserJourneyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetStakingUserJourneyQuery = {
	__typename?: "Query";
	settings: {
		__typename?: "Settings";
		userJourneys: {
			__typename?: "UserJourneys";
			staking: Array<string>;
			stakingLocked: Array<string>;
			unstaking: Array<string>;
			unstakingLocked: Array<string>;
			autoStaking: Array<string>;
			earning: Array<string>;
			earningLocked: Array<string>;
			releasing: Array<string>;
			releasingLocked: Array<string>;
			earnOnStableCoin: Array<string>;
		};
	};
};

export const GetStakingUserJourneyDocument = gql`
	query getStakingUserJourney {
		settings {
			userJourneys {
				staking
				stakingLocked
				unstaking
				unstakingLocked
				autoStaking
				earning
				earningLocked
				releasing
				releasingLocked
				earnOnStableCoin
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingUserJourneyGQLService extends Apollo.Query<
	GetStakingUserJourneyQuery,
	GetStakingUserJourneyQueryVariables
> {
	document = GetStakingUserJourneyDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
